const PARTNER = process.env.VUE_APP_PARTNER || 'DEFAULT'

export const FEATURE = {
  NOTIFICATION_CENTER: 'NOTIFICATION_CENTER',
  LOCK_ROLE_FOR_EXTERNAL_HR_USERS: 'LOCK_ROLE_FOR_EXTERNAL_HR_USERS',
}

const PARTNER_FEATURE = {
  DEFAULT: {
    [FEATURE.NOTIFICATION_CENTER]: false,
    [FEATURE.LOCK_ROLE_FOR_EXTERNAL_HR_USERS]: false,
  },
  HUGOL: {
    [FEATURE.NOTIFICATION_CENTER]: false,
    [FEATURE.LOCK_ROLE_FOR_EXTERNAL_HR_USERS]: true,
  },
  HALLAN: {
    [FEATURE.NOTIFICATION_CENTER]: true,
  },
  PORTALTELEMEDICINA: {
    [FEATURE.NOTIFICATION_CENTER]: false,
  },
  PORTALCONSULTAS: {
    [FEATURE.NOTIFICATION_CENTER]: false,
  },
}

export function hasPartnerFeature(flag) {
  const partnerOverrides = PARTNER_FEATURE[PARTNER] || {}
  return flag in partnerOverrides ? partnerOverrides[flag] : PARTNER_FEATURE.DEFAULT[flag]
}
